/**
 * Console control utility for production builds
 * Disables ALL console methods in production
 */

const isProduction = process.env.NODE_ENV === 'production' || 
                     process.env.REACT_APP_ENV === 'production';

export const disableProductionLogs = () => {
  if (isProduction) {
    // Disable ALL console methods in production
    console.log = function() {};
    console.debug = function() {};
    console.info = function() {};
    console.warn = function() {};
    console.error = function() {};
    console.trace = function() {};
    console.table = function() {};
  }
};

// Auto-initialize when module is imported
if (isProduction) {
  disableProductionLogs();
}

const consoleControl = {
  disableProductionLogs,
  isProduction
};

export default consoleControl;
